import React from 'react';
import { Truck } from 'lucide-react';
import { useTranslation } from '../../i18n';
import { VehicleRow } from './VehicleRow';
import FleetOpsTracker from './FleetOpsTracker';
import FleetFilters from './FleetFilters';
import RepairAllSection from './RepairAllSection';

const TIER_LABELS = {
  1: 'Tier 1 — Fourgons légers (< 3,5T)',
  2: 'Tier 2 — Porteurs (7T–12T)',
  3: 'Tier 3 — Semi-remorques (18T–26T)',
  4: 'Tier 4 — Spécialisés (ADR / Export)',
  5: 'Tier 5 — Premium / Prestige',
};

export function OwnedTab({
  vehicles,
  allVehicles,
  vehiclesByTier,
  filters,
  setFilters,
  drivers,
  treasury,
  totalDays,
  activeContracts,
  idleDrivers,
  maintainAllVehicles,
  playSound,
  expandedVehicle,
  setExpandedVehicle,
  getSellPrice,
  handleSell,
  maintainVehicle,
  assignDriverToVehicle,
  computeLeaseBuyout,
  setBuyoutTarget,
  setBreakLeaseTarget,
  fileInsuranceClaim,
  setClaimResult,
  toggleVehicleInterim,
}) {
  const { t } = useTranslation();
  const total = (allVehicles || vehicles).length;
  return (
    <div className="space-y-3">
      <FleetOpsTracker />

      <RepairAllSection vehicles={allVehicles || vehicles} treasury={treasury} maintainAllVehicles={maintainAllVehicles} playSound={playSound} />

      {total > 0 && <FleetFilters filters={filters} onChange={setFilters} total={total} shown={vehicles.length} />}

      {total === 0 ? (
        <div className="bg-ink-800 rounded-lg border border-ink-600 p-8 text-center">
          <Truck className="w-12 h-12 mx-auto text-slate-600 mb-3" />
          <p className="text-slate-500">{t('no_vehicle')}</p>
        </div>
      ) : vehicles.length === 0 ? (
        <div className="bg-ink-800 rounded-lg border border-ink-600 p-6 text-center text-sm text-slate-500" data-testid="fleet-filter-empty">
          Aucun véhicule ne correspond aux filtres.
        </div>
      ) : (
        vehiclesByTier.map(([tier, tierVehicles]) => (
          <div key={tier} className="space-y-2">
            <div className="flex items-center gap-2 mt-2">
              <div className="h-px flex-1 bg-ink-700" />
              <span className="text-[10px] font-bold text-slate-500 uppercase tracking-wider px-2" data-testid={`tier-header-${tier}`}>
                {TIER_LABELS[tier] || `Tier ${tier}`} ({tierVehicles.length})
              </span>
              <div className="h-px flex-1 bg-ink-700" />
            </div>
            {tierVehicles.map(v => (
              <VehicleRow
                key={v.id}
                v={v}
                drivers={drivers}
                treasury={treasury}
                totalDays={totalDays}
                activeContracts={activeContracts}
                idleDrivers={idleDrivers}
                expanded={expandedVehicle === v.id}
                setExpanded={setExpandedVehicle}
                getSellPrice={getSellPrice}
                handleSell={handleSell}
                maintainVehicle={maintainVehicle}
                assignDriverToVehicle={assignDriverToVehicle}
                computeLeaseBuyout={computeLeaseBuyout}
                setBuyoutTarget={setBuyoutTarget}
                setBreakLeaseTarget={setBreakLeaseTarget}
                fileInsuranceClaim={fileInsuranceClaim}
                setClaimResult={setClaimResult}
                toggleVehicleInterim={toggleVehicleInterim}
                playSound={playSound}
              />
            ))}
          </div>
        ))
      )}
    </div>
  );
}
